import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

import {beginSignIn as beginSignInAction, beginJoin as beginJoinAction} from 'actions/creators/Auth';

const messages = defineMessages({
    title: {
        id: 'coupon.menu.title',
        defaultMessage: 'Меню ставок'
    },
    to_configure_coupon: {
        id: 'betpanel.unauth.to_configure_coupon',
        defaultMessage: 'Чтобы менять настройки купона - '
    },
    should_auth: {
        id: 'betpanel.unauth.should_auth',
        defaultMessage: 'войдите'
    },
    should_register: {
        id: 'betpanel.unauth.should_register',
        defaultMessage: 'зарегистрируйтесь'
    },
    auth_or_register_to_bet: {
        id: 'betpanel.unauth.auth_or_register_to_bet',
        defaultMessage: '{signTrigger} или {joinTrigger}'
    }
});

class UnauthUserCouponDropDownMenu extends React.Component {
    static propTypes = {
        beginSignInAction: React.PropTypes.func.isRequired,
        beginJoinAction: React.PropTypes.func.isRequired,
        onClosing: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this._handleLogInClick = this._handleLogInClick.bind(this);
        this._handleJoinClick = this._handleJoinClick.bind(this);

        this._isInsidePopup = this._isInsidePopup.bind(this);
        this._onDocumentClick = this._onDocumentClick.bind(this);

        document.addEventListener('click', this._onDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onDocumentClick);
    }

    _isInsidePopup(element) {
        if (element === null) {
            return false;
        }

        if (element === this.refs.popup) {
            return true;
        }

        return this._isInsidePopup(element.parentElement);
    }

    _onDocumentClick(e) {
        if (this._isInsidePopup(e.target)) {
            return;
        }

        document.removeEventListener('click', this._onDocumentClick);

        this.props.onClosing();
    }

    _handleLogInClick(e) {
        e.preventDefault();
        this.props.beginSignInAction();
    }

    _handleJoinClick(e) {
        e.preventDefault();
        this.props.beginJoinAction();
    }

    render() {

        const signTrigger = (
            <FormattedMessage {...messages.should_auth}>
                {(message) => <a className="trigger" onClick={this._handleLogInClick}>{message}</a>}
            </FormattedMessage>

        );

        const joinTrigger = (
            <FormattedMessage {...messages.should_register}>
                {(message) => <a className="trigger" onClick={this._handleJoinClick}>{message}</a>}
            </FormattedMessage>
        );

        return (
            <ul ref="popup" className="dropdown--menu dropdown--menu-coupon  dropdown--menu__shown">
                <li className="title dropdown--menu__title dropdown--menu__item">
                        <span className="dropdown--menu__span">
                            <FormattedMessage {...messages.title} />
                        </span>
                </li>
                <li className="dropdown--menu__item dropdown--menu__item__favourites">
                    <div className="dropdown--menu-coupon__block__favourites dropdown--menu-coupon__block">
                        <label className="dropdown--menu-coupon__input__label">
                            <div className="auth-attention-modal">
                                <br />
                                <FormattedMessage {...messages.to_configure_coupon} />
                                &nbsp;
                                <FormattedMessage {...messages.auth_or_register_to_bet}
                                    values={{signTrigger, joinTrigger}} />
                            </div>

                        </label>
                    </div>
                </li>
            </ul>
        );
    }
}

function select() {
    return {};
}

export default connect(select, {beginSignInAction, beginJoinAction})(UnauthUserCouponDropDownMenu);


// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/UnauthUserCouponDropDownMenu.jsx